import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import Head from '../../../../layout/head/Head';
import Content from '../../../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../../components/Component';
import moment from 'moment';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import AuthTenantNoData from '../../../error/AuthTenantNoData';
import { TENANT_RETRIEVE_PROMOTION_DETAILS_API } from '../../../../api/api_data';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_promotion_details, loading_retrieve_promotion_details, reset_retrieve_promotion_details, success_retrieve_promotion_details } from '../../../../reducers/auth_tenant/retrieve_promotion_details_Slice';
import * as app_consts from "../../../../utils/app_consts";
import { RETRIEVE_PROMOTION_DETAILS_ERROR_MSG, RETRIEVE_PROMOTION_DETAILS_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { formatNumber, formatToSentenceCase, messageToast } from '../../../../utils/Utils';
import CardTabs from '../../../components/cards/CardTabs';
import { Alert, Badge, Card, Col, Row } from 'reactstrap';
import CreatePromotionDrawModal from '../../../../components/modal/promotions/CreatePromotionDrawModal';
import ViewPromotionDrawDetailsModal from '../../../../components/modal/promotions/ViewPromotionDrawDetailsModal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { motion, AnimatePresence } from "motion/react";
import { download, generateCsv, mkConfig } from 'export-to-csv';
import { Users } from 'react-feather';
import PromotionEntriesStatistics from '../dashboard/promotions_dashboard_data/PromotionEntriesStatistics';
import PromotionDrawsPrizeData from '../dashboard/promotions_dashboard_data/PromotionDrawsPrizeData';
import PromotionsTimeDistribution from '../dashboard/promotions_dashboard_data/PromotionsTimeDistribution';
import PromotionAgeDistribution from '../dashboard/promotions_dashboard_data/PromotionAgeDistribution';
import ViewCodesLookUpPromotionDetailsModal from '../../../../components/modal/promotions/ViewCodesLookUpPromotionDetailsModal';
import ViewMenuIdentifierPromotionDetailsModal from '../../../../components/modal/promotions/ViewMenuIdentifierPromotionDetailsModal';
import ViewRestrictedNumbersPromotionsDetailsModal from '../../../../components/modal/promotions/ViewRestrictedNumbersPromotionsDetailsModal';
import ViewMessagesPromotionDetailsModal from '../../../../components/modal/promotions/ViewMessagesPromotionDetailsModal';

const initialState = { initial_start_date: '', initial_end_date: '', start_date: '', end_date: '' };

const PromotionsDetails = ({ tenant_info, user_info }) => {

  const { promotion_id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeCardTab, setActiveCardTab] = useState("Summary");
  const [participantItemsPerPage] = useState(20);
  const [sm, updateSm] = useState(false);
  const [currentParticipantItemsPage, setCurrentParticipantPage] = useState(1);
  const [create_promotion_draw_modal, setCreatePromotionDrawModal] = useState(false);
  const [drawItemsPerPage] = useState(50);
  const [currentDrawItemsPage, setCurrentDrawPage] = useState(1);
  const [view_draw_modal, setViewDrawModal] = useState(false);
  const [selected_draw, setSelectedDraw] = useState('');
  const [searchText, setSearchText] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("ALL");
  const [filteredParticipants, setFilteredParticipants] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [form_data, setFormData] = useState(initialState);
  const [showPicker, setShowPicker] = useState(false);
  const [selectedRange, setSelectedRange] = useState([]);
  const [retriaval_loading, setRetrievalLoading] = useState(false);
  const [retrievalError, setRetrievalError] = useState("");
  const [view_codes_look_up_modal, setViewCodesLookUpModal] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [view_menu_identifier_modal, setViewMenuIdentifierModal] = useState(false);
  const [view_restricted_numbers_modal, setRestrictedNumbersModal] = useState(false);
  const [view_message_modal, setViewMessagesModal] = useState(false);

  const open_view_codes_look_up_modal = () => {
    setViewCodesLookUpModal(true);
  };

  const close_view_codes_look_up_modal = () => {
    setViewCodesLookUpModal(false);
  };

  const view_codes_look_up_modal_successFunction = () => {
    retrieve_data(false);
  };

  const open_view_menu_identifier_modal = () => {
    setViewMenuIdentifierModal(true);
  };

  const close_view_menu_identifier_modal = () => {
    setViewMenuIdentifierModal(false);
  };

  const view_menu_identifier_modal_successFunction = () => {
    retrieve_data(false);
  };

  const open_view_restricted_numbers_modal = () => {
    setRestrictedNumbersModal(true);
  };

  const close_view_restricted_numbers_modal = () => {
    setRestrictedNumbersModal(false);
  };

  const view_restricted_numbers_modal_successFunction = () => {
    retrieve_data(false);
  };

  const open_view_message_modal = () => {
    setViewMessagesModal(true);
  };

  const close_view_message_modal = () => {
    setViewMessagesModal(false);
  };

  const view_message_modal_successFunction = () => {
    retrieve_data(false);
  };

  const filterParticipants = () => {
    let data = page_data?.promotion_participants || [];

    // 🔍 SEARCH
    if (searchText)
    {
      data = data.filter((item) => {
        const combinedParams = [
          item?.participant?.first_name,
          item?.participant?.last_name,
          `${item?.participant?.first_name || ""} ${item?.participant?.last_name || ""}`,
          item?.participant?.mobile_number,
          item?.promotion_participant?.entry_code,
        ]
          .join(" ")
          .toLowerCase();

        return combinedParams.includes(searchText.toLowerCase());
      });
    }

    // 🎯 STATUS
    if (selectedStatus !== "ALL")
    {
      data = data.filter(
        (item) =>
          item?.promotion_participant?.code_status === selectedStatus
      );
    }

    // 📅 DATE RANGE (react-datepicker uses Date objects)
    if (startDate || endDate)
    {
      data = data.filter((item) => {
        const createdAt = item?.promotion_participant?.created_at;
        if (!createdAt) return false;

        const itemDate = new Date(createdAt);

        if (startDate && itemDate < startDate) return false;
        if (endDate && itemDate > endDate) return false;

        return true;
      });
    }

    setFilteredParticipants(data);
    setCurrentParticipantPage(1);
  };

  useEffect(() => {
    filterParticipants();
  }, [searchText, selectedStatus, page_data]);


  const paginate = (pageNumber) => setCurrentParticipantPage(pageNumber);
  const paginate_draw_item = (pageNumber) => setCurrentDrawPage(pageNumber);

  useEffect(() => {
    retrieve_data(true);
  }, []);

  const retrieve_data = (isInitial = false) => {
    setError("");
    if (isInitial)
    {
      setLoading(true);
    } else
    {
      setIsRefreshing(true);
    }
    dispatch(tenant_auth_actions_helper(loading_retrieve_promotion_details, success_retrieve_promotion_details, fail_retrieve_promotion_details, RETRIEVE_PROMOTION_DETAILS_ERROR_MSG, RETRIEVE_PROMOTION_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_PROMOTION_DETAILS_API}/${promotion_id}`));
  };

  // Listener
  const retrieve_promotion_details_listener = useSelector((state) => state.retrieve_promotion_details.retrieve_promotion_details);


  useEffect(() => {
    if (retrieve_promotion_details_listener?.status !== app_consts.IDLE)
    {
      if (retrieve_promotion_details_listener?.status === app_consts.LOADING)
      {
        setError("");
        // Don't set loading to true for refreshes
      } else
      {
        if (retrieve_promotion_details_listener?.status === app_consts.FAIL)
        {
          setError(retrieve_promotion_details_listener?.message);
          messageToast(retrieve_promotion_details_listener?.message, app_consts.FAIL);
          setLoading(false);
          setIsRefreshing(false);
        }
        if (retrieve_promotion_details_listener?.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_promotion_details_listener.data);
          setFormData({
            ...form_data,
            start_date: page_data?.promotion?.start_date ? moment(page_data?.promotion?.start_date).format("YYYY-MM-DD HH:mm:ss") : "",
            end_date: page_data?.promotion?.end_date ? moment(page_data?.promotion?.end_date).format("YYYY-MM-DD HH:mm:ss") : "",
          });
          setSelectedRange([page_data?.promotion?.start_date ? moment(page_data?.promotion?.start_date).format("YYYY-MM-DD HH:mm:ss") : "", page_data?.promotion?.end_date ? moment(page_data?.promotion?.end_date).format("YYYY-MM-DD HH:mm:ss") : ""]);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          // const invalid_participants =
          //   retrieve_promotion_details_listener.data?.promotion_participants?.filter((item) => {
          //     const createdAt = item?.promotion_participant?.created_at;

          //     return (
          //       item?.promotion_participant?.code_status === "invalid" &&
          //       createdAt &&
          //       moment(createdAt).isSameOrAfter(moment("2026-04-10"), "day")
          //     );
          //   });

          // const remapped_invalid_participants = invalid_participants?.map((item) => {
          //   return {
          //     name: `${item?.participant?.first_name} ${item?.participant?.middle_name ? item?.participant?.middle_name : ""} ${item?.participant?.last_name ? item?.participant?.last_name : ""}`,
          //     mobile_number: item?.participant?.mobile_number,
          //     email_address: item?.participant?.email_address,
          //     code: item?.promotion_participant?.entry_code,
          //     code_status: item?.promotion_participant?.code_status,
          //     location: item?.promotion_participant?.location,
          //     gender: item?.participant?.gender,
          //     dob: item?.participant?.dob ? moment(item?.participant?.dob).format('Do-MMM-YYYY') : "--",
          //     entry_date: item?.promotion_participant?.created_at ? moment(item?.promotion_participant?.created_at).format("YYYY-MM-DD HH:mm:ss") : "--",
          //     participant_status: item?.promotion_participant?.status
          //   };
          // });

          // console.log(remapped_invalid_participants);

          setIsRefreshing(false);
          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_promotion_details());
      }
    }
  }, [retrieve_promotion_details_listener]);


  // Card Tabs
  const tabs = [
    {
      tabName: "Summary"
    },
    {
      tabName: "Main Info"
    },
    {
      tabName: "Participants"
    },
    {
      tabName: "Draws"
    },
    {
      tabName: "Settings"
    }
  ];

  const indexOfLastParticipantItem = currentParticipantItemsPage * participantItemsPerPage;
  const indexOfFirstParticipantItem = indexOfLastParticipantItem - participantItemsPerPage;

  const currentParticipantItems = filteredParticipants?.slice(
    indexOfFirstParticipantItem,
    indexOfLastParticipantItem
  );

  const open_create_promotion_draw_modal = () => {
    setCreatePromotionDrawModal(true);
  };

  const close_create_promotion_draw_modal = () => {
    setCreatePromotionDrawModal(false);
  };

  const create_promotion_draw_modal_successFunction = () => {
    close_create_promotion_draw_modal();
    retrieve_data(false);
  };



  const indexOfLastDrawItem = currentDrawItemsPage * drawItemsPerPage;
  const indexOfFirstDrawItem = indexOfLastDrawItem - drawItemsPerPage;
  const currentDrawItems = page_data?.promotion_draws?.slice(indexOfFirstDrawItem, indexOfLastDrawItem);

  const open_view_draw_modal = (item) => {
    setViewDrawModal(true);
    setSelectedDraw(item);
  };

  const close_view_draw_modal = () => {
    setViewDrawModal(false);
    setSelectedDraw("");
  };

  const view_draw_modal_successFunction = () => {
    close_view_draw_modal();
    retrieve_data(false);
  };

  const handleExportCSV = async (e) => {
    e.preventDefault();
    const cur_dt = moment().format("DD-MM-YYYY h:mm:ss a");

    // Headers
    const csv_headers = ["Name", "Gender", "Mobile_number", "Location", "Place", "Code", "Status", "Entry Date"];
    const csv_data = filteredParticipants?.map((item) => {
      return {
        name: `${item?.participant?.first_name} ${item?.participant?.middle_name ? item?.participant?.middle_name : ""} ${item?.participant?.last_name}`,
        gender: item?.participant?.gender,
        mobile_number: item?.participant?.mobile_number,
        location: item?.promotion_participant?.location,
        place: item?.promotion_participant?.place,
        code: item?.promotion_participant?.entry_code,
        status: item?.promotion_participant?.code_status,
        entry_date: item?.promotion_participant?.inserted_at ? moment(item?.promotion_participant?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "",
      };
    });

    const options = mkConfig({
      fieldSeparator: ',',
      quoteStrings: '"',
      showLabels: true,
      showTitle: false,
      title: " ",
      useTextFile: false,
      useBom: true,
      filename: `${page_data?.promotion?.name ? `${page_data?.promotion?.name} Promotion Participancts` : "Promotion Participancts"} - Generated on ${cur_dt}`,
      useKeysAsHeaders: true,
      columnHeaders: csv_headers,
    });

    const csv = generateCsv(options)(csv_data || []);

    download(options)(csv);

  };

  const handleCustomRange = () => {
    setShowPicker(!showPicker);
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;

    setSelectedRange([start, end]); // This updates the calendar UI

    if (start && end)
    {
      setFormData({
        ...form_data,
        start_date: moment(start).format("YYYY-MM-DD 00:00:00"),
        end_date: moment(end).format("YYYY-MM-DD 23:59:59"),
      });
    }
  };



  const handleApply = () => {
    if (selectedRange.length === 2)
    {
      // retrieve_data();
      setShowPicker(false);
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  const settingsItems = [
    {
      id: "code_lookup",
      name: "Code Lookup Integration",
      icon: "mobile",
      test_bool: true,
      button_click_function: () => {
        open_view_codes_look_up_modal();
      },
      set_value: page_data?.settings_check?.code_look_up_integration_set,
    },

    {
      id: "notifications",
      name: "Notifications Configuration",
      icon: "bell",
      test_bool: false,
      button_click_function: () => {
        return null;
      },
      set_value: page_data?.settings_check?.notifications_set,
    },

    {
      id: "messages",
      name: "Messages",
      icon: "message",
      test_bool: true,
      button_click_function: () => {
        open_view_message_modal();
      },
      set_value: page_data?.settings_check?.messages_settings_set,
    },
    {
      id: "restricted_numbers",
      name: "Restricted Numbers",
      icon: "phone-off",
      test_bool: false,
      button_click_function: () => {
        open_view_restricted_numbers_modal();
      },
      set_value: page_data?.settings_check?.restricted_numbers_identifier_set,
    },
    {
      id: "menu_identifier",
      name: "Menu Identifier",
      icon: "phone-off",
      test_bool: false,
      button_click_function: () => {
        open_view_menu_identifier_modal();
      },
      set_value: page_data?.settings_check?.menu_identifier_set,
    }
  ];

  return (
    <>
      <Head title="Promotion Details"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Promotion / <strong className="text-primary small">{page_data?.promotion?.name ? page_data?.promotion?.name : "--"}</strong>
              </BlockTitle>
              <BlockDes className="text-soft">
                <ul className="list-inline">
                  <li>
                    Description: <span className="text-base">{page_data?.promotion?.description ? page_data?.promotion?.description : "--"}</span>
                  </li>
                </ul>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button
                color="light"
                outline
                className="bg-white d-none d-sm-inline-flex"
                onClick={() => navigate(-1)}
              >
                <Icon name="arrow-left"></Icon>
                <span>Back</span>
              </Button>
              <a
                href="#back"
                onClick={(ev) => {
                  ev.preventDefault();
                  navigate(-1);
                }}
                className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
              >
                <Icon name="arrow-left"></Icon>
              </a>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Promotion Details..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data ?
                        <>
                          <Block>
                            <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                            {
                              activeCardTab === "Summary" && (
                                <>
                                  <Row className="g-gs" style={{ marginBottom: '20px' }}>
                                    <motion.div
                                      className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between flex-wrap bg-light p-3 mb-3"
                                      initial={{ opacity: 0, y: -10 }}
                                      animate={{ opacity: 1, y: 0 }}
                                      transition={{ duration: 0.4 }}
                                    >
                                      <div className="mb-2 mb-sm-0">

                                        {/* Toggle Button */}
                                        {/* <div className="d-flex align-items-center mb-2">
                                          <Button color="primary" size="sm" onClick={handleCustomRange}>
                                            {showPicker ? "Cancel" : "Custom Range"}
                                          </Button>
                                        </div> */}

                                        {/* Conditional Date Range Picker */}
                                        {/* {showPicker && (
                                          <motion.div
                                            initial={{ opacity: 0, y: -10 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.3 }}
                                            className="mb-3"
                                          >
                                            <label className="form-label fw-semibold text-muted mb-1">
                                              Select Date Range
                                            </label>

                                            <DatePicker
                                              selected={selectedRange[0]}
                                              onChange={handleDateChange}
                                              startDate={selectedRange[0]}
                                              endDate={selectedRange[1]}
                                              selectsRange
                                              minDate={page_data?.promotion?.start_date ? moment(page_data?.promotion?.start_date).format("YYYY-MM-DD HH:mm:ss") : ""}
                                              maxDate={page_data?.promotion?.end_date ? moment(page_data?.promotion?.end_date).format("YYYY-MM-DD HH:mm:ss") : ""}
                                              dateFormat="yyyy-MM-dd"
                                              className="form-control"
                                            />

                                            <Button
                                              color="success"
                                              size="sm"
                                              className="mt-2"
                                              onClick={handleApply}
                                              disabled={!form_data?.start_date || !form_data?.end_date || retriaval_loading}
                                            >
                                              {retriaval_loading ? "Retrieving Data" : "Apply"}
                                            </Button>

                                            {retrievalError && (
                                              <Alert className="my-4" color="danger">
                                                {retrievalError}
                                              </Alert>
                                            )}
                                          </motion.div>
                                        )} */}

                                        {/* Display current date info */}
                                        {!showPicker && (
                                          <motion.div
                                            initial={{ opacity: 0, y: -10 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.3 }}
                                          >
                                            <motion.div
                                              className="bg-light border-start border-primary ps-3 py-2 mb-3 rounded"
                                              initial={{ opacity: 0, x: -20 }}
                                              animate={{ opacity: 1, x: 0 }}
                                              transition={{ duration: 0.4, delay: 0.1 }}
                                            >
                                              <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                                                📅 Showing data from{" "}
                                                <span className="fw-semibold text-dark">
                                                  {form_data?.start_date}
                                                </span>{" "}
                                                up to{" "}
                                                <span className="fw-semibold text-dark">
                                                  {form_data?.end_date}
                                                </span>.
                                              </p>
                                            </motion.div>
                                          </motion.div>
                                        )}

                                      </div>
                                    </motion.div>

                                    <motion.div variants={itemVariants} className="col-xxl-12 col-md-12">
                                      <Card className="h-100 shadow-sm">
                                        <div className="p-4">
                                          <div className="d-flex justify-content-between align-items-center mb-4">
                                            <h5 className="fw-bold mb-0">Participation Overview</h5>
                                          </div>
                                          <Row className="g-gs">
                                            <motion.div variants={itemVariants} className="col-xxl-5 col-md-6">

                                              <Row className="g-gs">
                                                <Col md={6}>
                                                  <div className="bg-light bg-opacity-50 rounded-3 p-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                      <Users size={20} className="text-success me-2" />
                                                      <span className="text-muted small">Total Entries</span>
                                                    </div>
                                                    <div className="h2 fw-bold mb-0">{page_data?.summary?.participation_overview?.total_entries || "0"}</div>
                                                  </div>
                                                </Col>
                                                <Col md={6}>
                                                  <div className="bg-light bg-opacity-50 rounded-3 p-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                      <Users size={20} className="text-success me-2" />
                                                      <span className="text-muted small">Total Unique Entries</span>
                                                    </div>
                                                    <div className="h2 fw-bold mb-0">{page_data?.summary?.participation_overview?.unique_participants || "0"}</div>
                                                  </div>
                                                </Col>
                                                <Col md={6}>
                                                  <div className="bg-light bg-opacity-50 rounded-3 p-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                      <Users size={20} className="text-success me-2" />
                                                      <span className="text-muted small">
                                                        Average Entries (Active Days)
                                                      </span>
                                                    </div>

                                                    <div className="h2 fw-bold mb-0">
                                                      {formatNumber(page_data?.summary?.participation_overview?.avg_active_days || "0")}
                                                    </div>

                                                    {/* 👇 Added context */}
                                                    <div className="text-muted small mt-1">
                                                      {page_data?.summary?.participation_overview?.active_days || 0} active days
                                                    </div>
                                                  </div>
                                                </Col>

                                                <Col md={6}>
                                                  <div className="bg-light bg-opacity-50 rounded-3 p-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                      <Users size={20} className="text-success me-2" />
                                                      <span className="text-muted small">
                                                        Average Entries (Full Range)
                                                      </span>
                                                    </div>

                                                    <div className="h2 fw-bold mb-0">
                                                      {formatNumber(page_data?.summary?.participation_overview?.avg_full_range || "0")}
                                                    </div>

                                                    {/* 👇 Added context */}
                                                    <div className="text-muted small mt-1">
                                                      {page_data?.summary?.participation_overview?.active_days || 0} /{" "}
                                                      {page_data?.summary?.participation_overview?.total_days || 0} days
                                                    </div>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </motion.div>

                                            <motion.div variants={itemVariants} className="col-xxl-7 col-md-6">
                                              <PromotionEntriesStatistics data={page_data?.summary?.entry_dates} heading={"Entries Distribution Over time"} />
                                            </motion.div>
                                          </Row>
                                        </div>
                                      </Card>
                                    </motion.div>

                                    <motion.div variants={itemVariants} className="col-xxl-12 col-md-12">
                                      <Card className="h-100 shadow-sm">
                                        <div className="p-4">
                                          <div className="d-flex justify-content-between align-items-center mb-4">
                                            <h5 className="fw-bold mb-0">Draws Activity</h5>
                                          </div>
                                          <Row className="g-gs">

                                            <motion.div variants={itemVariants} className="col-xxl-7 col-md-6">
                                              <PromotionDrawsPrizeData data={page_data?.summary?.prize_distribution} heading={"Promotion Draws Distribution Data"} />
                                            </motion.div>
                                            <motion.div variants={itemVariants} className="col-xxl-5 col-md-6">

                                              <Row className="g-gs">
                                                <Col md={6}>
                                                  <div className="bg-light bg-opacity-50 rounded-3 p-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                      <Users size={20} className="text-success me-2" />
                                                      <span className="text-muted small">Total Draws</span>
                                                    </div>
                                                    <div className="h2 fw-bold mb-0">{page_data?.summary?.total_draws_count || "0"}</div>
                                                  </div>
                                                </Col>
                                                <Col md={6}>
                                                  <div className="bg-light bg-opacity-50 rounded-3 p-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                      <Users size={20} className="text-success me-2" />
                                                      <span className="text-muted small">Total Valid Participants</span>
                                                    </div>
                                                    <div className="h2 fw-bold mb-0">{page_data?.summary?.total_valid_draw_participants_count || "0"}</div>
                                                  </div>
                                                </Col>
                                                <Col md={6}>
                                                  <div className="bg-light bg-opacity-50 rounded-3 p-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                      <Users size={20} className="text-success me-2" />
                                                      <span className="text-muted small">Total Awarded Participants</span>
                                                    </div>
                                                    <div className="h2 fw-bold mb-0">{page_data?.summary?.awarded_participants || "0"}</div>
                                                  </div>
                                                </Col>
                                                <Col md={6}>
                                                  <div className="bg-light bg-opacity-50 rounded-3 p-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                      <Users size={20} className="text-success me-2" />
                                                      <span className="text-muted small">Participant to Win Ratio</span>
                                                    </div>
                                                    <div className="h2 fw-bold mb-0">{page_data?.summary?.participation_to_win_ratio || "0"}</div>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </motion.div>
                                          </Row>
                                        </div>
                                      </Card>
                                    </motion.div>

                                    <motion.div variants={itemVariants} className="col-xxl-12 col-md-12">
                                      <Card className="h-100 shadow-sm">
                                        <div className="p-4">
                                          <div className="d-flex justify-content-between align-items-center mb-4">
                                            <h5 className="fw-bold mb-0">Age and Time Distribution</h5>
                                          </div>
                                          <Row className="g-gs">
                                            <motion.div variants={itemVariants} className="col-xxl-6 col-md-6">
                                              <PromotionsTimeDistribution r_data={page_data?.summary?.time_range_distribution} />
                                            </motion.div>
                                            <motion.div variants={itemVariants} className="col-xxl-6 col-md-6">
                                              <PromotionAgeDistribution r_data={page_data?.summary?.age_range_distribution} />
                                            </motion.div>
                                          </Row>
                                        </div>




                                      </Card>
                                    </motion.div>

                                  </Row>
                                </>
                              )
                            }
                            {
                              activeCardTab === "Main Info" && (
                                <>
                                  <div className="card-inner bg-white">
                                    <Block>
                                      <BlockHead>
                                        <BlockTitle tag="h5">Main Information</BlockTitle>
                                      </BlockHead>
                                      <div className="profile-ud-list">
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">Name</span>
                                            <span className="profile-ud-value">{page_data?.promotion?.name ? page_data?.promotion?.name : "--"}</span>
                                          </div>
                                        </div>
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">Description</span>
                                            <span className="profile-ud-value">{page_data?.promotion?.description || "--"}</span>
                                          </div>
                                        </div>
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">Type</span>
                                            <span className="profile-ud-value">{page_data?.promotion?.type?.replace(/_/g, ' ').toUpperCase() || "--"}</span>
                                          </div>
                                        </div>
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">Start Date</span>
                                            <span className="profile-ud-value">{page_data?.promotion?.start_date ? moment(page_data?.promotion?.start_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                          </div>
                                        </div>
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">End Date</span>
                                            <span className="profile-ud-value">{page_data?.promotion?.end_date ? moment(page_data?.promotion?.end_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                          </div>
                                        </div>
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">Created On</span>
                                            <span className="profile-ud-value">{page_data?.promotion?.inserted_at ? moment(page_data?.promotion?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                          </div>
                                        </div>
                                        {
                                          page_data?.promotion?.type === app_consts.USSD ?
                                            <>
                                              <div className="profile-ud-item">
                                                <div className="profile-ud wider">
                                                  <span className="profile-ud-label">USSD Code</span>
                                                  <span className="profile-ud-value">{page_data?.promotion?.ussd_code?.replace(/_/g, ' ').toUpperCase() || "--"}</span>
                                                </div>
                                              </div>
                                            </>
                                            :
                                            <>

                                            </>
                                        }
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">Status</span>
                                            <span className="profile-ud-value">
                                              <span className="tb-odr-status">
                                                <Badge
                                                  color={
                                                    page_data?.promotion?.status === app_consts.ACTIVE
                                                      ? "success"
                                                      : "danger"
                                                  }
                                                  className="badge-dot"
                                                >
                                                  {page_data?.promotion?.status?.toUpperCase() || "--"}
                                                </Badge>
                                              </span></span>
                                          </div>
                                        </div>
                                      </div>
                                    </Block>
                                  </div>
                                </>
                              )
                            }
                            {
                              activeCardTab === "Participants" && (
                                <>
                                  <div className="card-inner bg-white">
                                    <Block>
                                      <BlockHead>
                                        <BlockBetween>
                                          <BlockTitle tag="h5">Participants</BlockTitle>

                                          <BlockHeadContent>
                                            <div className="d-flex align-items-center gap-2">

                                              <div className="form-control-wrap" style={{ width: "260px" }}>
                                                <div className="form-icon form-icon-right">
                                                  <Icon name="search" />
                                                </div>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  value={searchText}
                                                  onChange={(e) => setSearchText(e.target.value)}
                                                  placeholder="Search participants..."
                                                />
                                              </div>

                                              <Button
                                                color="light"
                                                className="btn-dim"
                                                onClick={() => updateSm(!sm)}
                                              >
                                                <Icon name="filter" /> Filters
                                              </Button>

                                              {/*  Export CSV */}
                                              {filteredParticipants.length > 0 && (
                                                <Button
                                                  color="primary"
                                                  className="btn-dim"
                                                  onClick={handleExportCSV}
                                                >
                                                  <Icon name="download" /> Export to CSV
                                                </Button>
                                              )}
                                            </div>
                                          </BlockHeadContent>
                                        </BlockBetween>

                                        <AnimatePresence>
                                          {sm && (
                                            <motion.div
                                              initial={{ opacity: 0, y: -10 }}
                                              animate={{ opacity: 1, y: 0 }}
                                              exit={{ opacity: 0, y: -10 }}
                                              transition={{ duration: 0.2 }}
                                              style={{ overflow: "visible" }}
                                            >
                                              <div className="card-inner border-top mt-2">
                                                <div className="d-flex flex-wrap gap-3 align-items-end">

                                                  {/* 📅 Date Range */}
                                                  <div style={{ minWidth: "220px" }}>
                                                    <label className="form-label">Date Range</label>
                                                    <DatePicker
                                                      selectsRange
                                                      startDate={startDate}
                                                      endDate={endDate}
                                                      onChange={(dates) => {
                                                        const [start, end] = dates;
                                                        setStartDate(start);
                                                        setEndDate(end);
                                                      }}
                                                      className="form-control"
                                                      dateFormat="yyyy-MM-dd"
                                                      isClearable
                                                      placeholderText="Select range"
                                                    />
                                                  </div>

                                                  {/* 🎯 Status */}
                                                  <div style={{ minWidth: "160px" }}>
                                                    <label className="form-label">Status</label>
                                                    <select
                                                      className="form-select"
                                                      value={selectedStatus}
                                                      onChange={(e) => setSelectedStatus(e.target.value)}
                                                    >
                                                      <option value="ALL">All</option>
                                                      <option value={app_consts.VALID}>Valid</option>
                                                      <option value={app_consts.INVALID}>Invalid</option>
                                                    </select>
                                                  </div>

                                                  {/* 🧹 Clear Filters */}
                                                  <div>
                                                    <Button
                                                      color="light"
                                                      className="btn-dim"
                                                      onClick={() => {
                                                        setStartDate(null);
                                                        setEndDate(null);
                                                        setSelectedStatus("ALL");
                                                        setSearchText("");
                                                      }}
                                                    >
                                                      Clear
                                                    </Button>
                                                  </div>

                                                </div>
                                              </div>
                                            </motion.div>
                                          )}
                                        </AnimatePresence>
                                      </BlockHead>
                                      <div className="nk-tb-list is-separate is-medium mb-3 mt-2">
                                        <DataTableHead className="nk-tb-item">
                                          <DataTableRow>
                                            <span className="sub-text">Name</span>
                                          </DataTableRow>
                                          <DataTableRow>
                                            <span className="sub-text">Contact</span>
                                          </DataTableRow>
                                          <DataTableRow>
                                            <span className="sub-text">Code</span>
                                          </DataTableRow>
                                          <DataTableRow size="lg">
                                            <span className="sub-text">Place/Location</span>
                                          </DataTableRow>
                                          <DataTableRow size="lg">
                                            <span className="sub-text">Gender</span>
                                          </DataTableRow>
                                          <DataTableRow size="lg">
                                            <span className="sub-text">DOB</span>
                                          </DataTableRow>
                                          <DataTableRow size="lg">
                                            <span className="sub-text">Entry Date</span>
                                          </DataTableRow>
                                          <DataTableRow size="md">
                                            <span className="sub-text">Status</span>
                                          </DataTableRow>
                                          <DataTableRow size="md">
                                            <span className="sub-text">Action</span>
                                          </DataTableRow>
                                        </DataTableHead>
                                        {/*Head*/}
                                        {currentParticipantItems?.length > 0
                                          ? currentParticipantItems?.map((item) => (
                                            <DataTableItem key={item.id}>
                                              <DataTableRow>
                                                <span className="tb-product">
                                                  <span className="tb-sub">{item?.participant?.first_name ? `${item?.participant?.first_name} ${item?.participant?.middle_name ? item?.participant?.middle_name : ""} ${item?.participant?.last_name ? item?.participant?.last_name : ""}` : "--"}</span>
                                                </span>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <div className="user-card">
                                                  <div className="user-info">
                                                    <span className="tb-lead">
                                                      {item?.participant?.mobile_number || "--"}
                                                    </span>
                                                    <span>MNO | {item?.participant?.mobile_network_provider?.replace(/_/g, ' ').toUpperCase() || "--"}</span>
                                                  </div>
                                                </div>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <div className="user-card">
                                                  <div className="user-info">
                                                    <span className="tb-lead">{item?.promotion_participant?.entry_code}</span>
                                                    <span>
                                                      <Badge
                                                        color={
                                                          item?.promotion_participant?.code_status === app_consts.VALID
                                                            ? "success"
                                                            : "warning"
                                                        }
                                                        className="badge-dot"
                                                      >
                                                        {item?.promotion_participant?.code_status ? formatToSentenceCase(item?.promotion_participant?.code_status)?.toUpperCase() : "--"}
                                                      </Badge>
                                                    </span>
                                                  </div>
                                                </div>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <div className="user-card">
                                                  <div className="user-info">
                                                    <span className="tb-lead">
                                                      {item?.promotion_participant?.place || "--"}
                                                    </span>
                                                    <span>{item?.promotion_participant?.location || "--"}</span>
                                                  </div>
                                                </div>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <span className="tb-sub">{item?.participant?.gender || "--"}</span>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <span className="tb-sub">{item?.participant?.dob ? moment(item?.participant?.dob).format('Do-MMM-YYYY') : "--"}</span>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <span className="tb-sub">{item?.promotion_participant?.created_at ? moment(item?.promotion_participant?.created_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <div className="user-card">
                                                  <div className="user-info">
                                                    <span className="tb-lead">
                                                      <span className="tb-odr-status">
                                                        <Badge
                                                          color={
                                                            item?.promotion_participant?.status === app_consts.ACTIVE
                                                              ? "success"
                                                              : "warning"
                                                          }
                                                          className="badge-dot"
                                                        >
                                                          {item?.promotion_participant?.status ? formatToSentenceCase(item?.promotion_participant?.status)?.toUpperCase() : "--"}
                                                        </Badge>
                                                      </span>
                                                    </span>
                                                  </div>
                                                </div>
                                              </DataTableRow>
                                              <DataTableRow className="nk-tb-col-tools">
                                                <div className="tb-odr-btns d-none d-sm-inline">
                                                  <Button color="primary" size="sm" className="btn btn-dim">
                                                    View
                                                  </Button>
                                                </div>
                                                <Button className="btn-pd-auto d-sm-none">
                                                  <Icon name="chevron-right"></Icon>
                                                </Button>
                                              </DataTableRow>
                                            </DataTableItem>
                                          ))
                                          :
                                          <>
                                            <AuthTenantNoData tenant_info={tenant_info} no_data_message={"Participants Not Found"} />
                                          </>
                                        }
                                      </div>
                                      {currentParticipantItems?.length > 0 && (
                                        <div className="mt-3">
                                          <PaginationComponent
                                            itemPerPage={participantItemsPerPage}
                                            totalItems={filteredParticipants?.length}
                                            paginate={paginate}
                                            currentPage={currentParticipantItemsPage}
                                          />
                                        </div>
                                      )}
                                    </Block>
                                  </div>
                                </>
                              )
                            }
                            {
                              activeCardTab === "Draws" && (
                                <>
                                  <div className="card-inner bg-white">
                                    <Block>
                                      <BlockHead>
                                        <BlockTitle tag="h5">Draws</BlockTitle>
                                      </BlockHead>
                                      {
                                        (user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.CREATE_PROMOTION_DRAW)) && (
                                          <>
                                            <Button color="primary" onClick={open_create_promotion_draw_modal}>
                                              Create Promotion Draw
                                            </Button>
                                          </>
                                        )
                                      }
                                      {
                                        page_data?.promotion_draws && page_data?.promotion_draws?.length > 0 ?
                                          <>
                                            <div className="nk-tb-list is-separate is-medium mb-3">
                                              <DataTableHead className="nk-tb-item">
                                                <DataTableRow>
                                                  <span className="sub-text">Draw Date</span>
                                                </DataTableRow>
                                                <DataTableRow>
                                                  <span className="sub-text">Draw Type</span>
                                                </DataTableRow>
                                                <DataTableRow>
                                                  <span className="sub-text">Valid Draw Entries</span>
                                                </DataTableRow>
                                                <DataTableRow>
                                                  <span className="sub-text">Status</span>
                                                </DataTableRow>
                                                <DataTableRow size="lg">
                                                  <span className="sub-text">Action</span>
                                                </DataTableRow>
                                              </DataTableHead>
                                              {currentDrawItems?.length > 0
                                                ? currentDrawItems?.map((item) => (
                                                  <DataTableItem key={item.id}>
                                                    <DataTableRow>
                                                      <span className="tb-product">
                                                        <span className="tb-sub">{item?.draw_at ? moment(item?.draw_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                                      </span>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <span className="tb-product">
                                                        <span className="tb-sub">{item?.draw_type ? formatToSentenceCase(item?.draw_type)?.toUpperCase() : "--"}</span>
                                                      </span>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <span className="tb-product">
                                                        <span className="tb-sub">{item?.participant_count || "--"}</span>
                                                      </span>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <div className="user-card">
                                                        <div className="user-info">
                                                          <span>
                                                            <Badge
                                                              color={
                                                                item?.status === app_consts.COMPLETED_LOWER
                                                                  ? "success"
                                                                  : "warning"
                                                              }
                                                              className="badge-dot"
                                                            >
                                                              {item?.status ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                                                            </Badge>
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </DataTableRow>
                                                    <DataTableRow className="nk-tb-col-tools">
                                                      <div className="tb-odr-btns d-none d-sm-inline">
                                                        <Button color="primary" size="sm" className="btn btn-dim" onClick={() => open_view_draw_modal(item?.id)}>
                                                          View
                                                        </Button>
                                                      </div>
                                                      <Button className="btn-pd-auto d-sm-none">
                                                        <Icon name="chevron-right"></Icon>
                                                      </Button>
                                                    </DataTableRow>
                                                  </DataTableItem>
                                                ))
                                                :
                                                <>

                                                </>
                                              }
                                            </div>
                                          </>
                                          :
                                          <>
                                            <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Draws Found"} />
                                          </>
                                      }
                                      {currentDrawItems?.length > 0 && (
                                        <div className="mt-3">
                                          <PaginationComponent
                                            itemPerPage={participantItemsPerPage}
                                            totalItems={filteredParticipants?.length}
                                            paginate={paginate}
                                            currentPage={currentParticipantItemsPage}
                                          />
                                        </div>
                                      )}
                                    </Block>
                                  </div>
                                  {
                                    (user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.CREATE_PROMOTION_DRAW)) && (
                                      <>
                                        <CreatePromotionDrawModal tenant_info={tenant_info} user_info={user_info} isOpen={create_promotion_draw_modal} closeModal={close_create_promotion_draw_modal} successFunction={create_promotion_draw_modal_successFunction} data={page_data} />
                                      </>
                                    )
                                  }
                                  <ViewPromotionDrawDetailsModal tenant_info={tenant_info} user_info={user_info} data={selected_draw} successFunction={view_draw_modal_successFunction} isOpen={view_draw_modal} closeModal={close_view_draw_modal} />
                                </>
                              )
                            }
                            {
                              activeCardTab === "Settings" && (
                                <>
                                  <Block>
                                    <BlockHead>
                                      <BlockTitle tag="h5">Settings</BlockTitle>
                                    </BlockHead>

                                    <Row className="g-gs">
                                      {settingsItems.map((item) => (
                                        <Col xxl="6" key={item.id}>
                                          <div className="nk-download">
                                            <div className="data">
                                              <div className="thumb">
                                                <Icon name={item.icon} style={{ fontSize: "32px" }} />
                                              </div>

                                              <div className="info" style={{ flex: 1 }}>
                                                <h6 className="title">
                                                  <span className="name">{item.name}</span>
                                                </h6>

                                                <div className="meta">
                                                  <span className="status" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                    <span>
                                                      <span className="text-soft">Status: </span>
                                                      <span className={item?.set_value === "set" ? "text-success" : "text-danger"}>
                                                        {item?.set_value?.replace(/_/g, ' ').toUpperCase() || "--"}
                                                      </span>
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>

                                            {/* Edit button - below status, left side */}
                                            {
                                              (user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                <div className="d-flex justify-content-start mt-4">
                                                  <Button
                                                    className="toggle d-md-inline-flex"
                                                    color="primary"
                                                    onClick={item.button_click_function}
                                                  >
                                                    <Icon name="eye"></Icon>
                                                    <span>View</span>
                                                  </Button>
                                                </div>
                                              )
                                            }
                                          </div>
                                        </Col>
                                      ))}
                                      <ViewCodesLookUpPromotionDetailsModal isOpen={view_codes_look_up_modal} closeModal={close_view_codes_look_up_modal} tenant_info={tenant_info} user_info={user_info} successFunction={view_codes_look_up_modal_successFunction} data={promotion_id} />

                                      <ViewMenuIdentifierPromotionDetailsModal isOpen={view_menu_identifier_modal} closeModal={close_view_menu_identifier_modal} tenant_info={tenant_info} user_info={user_info} successFunction={view_menu_identifier_modal_successFunction} data={promotion_id} />

                                      <ViewRestrictedNumbersPromotionsDetailsModal isOpen={view_restricted_numbers_modal} closeModal={close_view_restricted_numbers_modal} tenant_info={tenant_info} user_info={user_info} successFunction={view_restricted_numbers_modal_successFunction} data={promotion_id} />

                                      <ViewMessagesPromotionDetailsModal isOpen={view_message_modal} closeModal={close_view_message_modal} tenant_info={tenant_info} user_info={user_info} successFunction={view_message_modal_successFunction} data={promotion_id} />



                                    </Row>
                                  </Block>
                                </>
                              )
                            }
                          </Block>
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"Promotions Data Not Found"} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>
    </>
  );
};

export default PromotionsDetails;